import * as React from "react";
import { useSelector } from "react-redux";

import { SpacingToken } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { getFilteredInstalledApplications } from "store/entities/applications";
import { withVar } from "themes/helpers";

import ApplicationItem from "../../components/ApplicationItem";
import { defaultIntegrations } from "../../constants";

const InstalledApps: React.FC = () => {
  const applications = useSelector(getFilteredInstalledApplications);

  return (
    <Flex column gap={withVar(SpacingToken.Spacing3)} marginBottom="60px" marginTop={withVar(SpacingToken.Spacing3)}>
      {[...defaultIntegrations, ...applications].map(application => (
        <ApplicationItem key={application?.id} hideInstalledBadge application={application} />
      ))}
    </Flex>
  );
};

export default InstalledApps;
